import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { floor, formatNumber, decimalPlaces } from '../../utils/number'
import FlexBox from '../common/FlexBox'
import zIndex from '../../utils/zIndexScale'

const Text = styled(FlexBox)`
  justify-content: ${({ textAlign }) => textAlign};
  position: relative;
  z-index: ${zIndex.textContent};
`

class Amount extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAlign: PropTypes.string,
    lotSize: PropTypes.string,
    tickerSize: PropTypes.string,
    type: PropTypes.string,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    value: 0,
    price: 0,
    textAlign: 'flex-start',
    lotSize: '0.00000001',
    tickerSize: '0.00000001',
    type: '',
    onClick: () => {},
  }

  _calValue = () => {
    const { value, lotSize } = this.props
    let ts = 8
    if (lotSize) {
      ts = Math.abs(Math.log10(lotSize))
    }
    return floor(value, ts)
  }

  _calPrice = () => {
    const { price, tickerSize } = this.props
    let ts = 8
    if (tickerSize) {
      ts = decimalPlaces(tickerSize)
    }
    return floor(price, ts)
  }

  _handleClick = () => {
    const { onClick, type } = this.props
    const amount = this._calValue()
    onClick && onClick(this._calPrice(), amount, type)
  }

  render() {
    const amount = this._calValue()
    const { lotSize, textAlign } = this.props
    return (
      <Text onClick={this._handleClick} textAlign={textAlign}>
        {formatNumber(amount, decimalPlaces(lotSize))}
      </Text>
    )
  }
}

const mapStateToProps = ({ exchange: { currentTrade }, tickers: { lotSize, tickerSize } }) => ({
  lotSize: decimalPlaces(lotSize[currentTrade]) > 6 ? lotSize[currentTrade] : '0.000001',
  tickerSize: decimalPlaces(tickerSize[currentTrade]) > 6 ? tickerSize[currentTrade] : '0.000001',
})

export default connect(mapStateToProps)(Amount)
